var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVeryPoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M350,1C157.3,1,1,157.3,1,350s156.3,349,349,349s349-156.3,349-349C699,157.3,542.7,1,350,1z M350,627.1 C197.1,627.1,72.9,502.9,72.9,350C72.9,197.2,197.2,72.9,350,72.9c152.9,0,277.1,124.3,277.1,277.1 C627.1,502.9,502.9,627.1,350,627.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.3,241.9c0,24.7-20,44.7-44.7,44.7c-24.7,0-44.7-20-44.7-44.7s20-44.7,44.7-44.7C284.3,197.2,304.3,217.2,304.3,241.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.8,241.9c0,24.7-20,44.7-44.7,44.7s-44.7-20-44.7-44.7s20-44.7,44.7-44.7S476.8,217.2,476.8,241.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,381.5c-83.8-0.7-156.3,48.9-189.2,120.8h61.4c27.9-41.2,74.7-67.7,127-67c51,0.7,94.9,25.8,122.2,64.2 c20.2,0,41.2-0.7,61.4-1.4C496.3,430.4,426.5,382.9,345.5,381.5L345.5,381.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryPoor);
export default __webpack_public_path__ + "static/media/very-poor.44e28bb3a86bcb0a7e6c5e4e2f364013.svg";
export { ForwardRef as ReactComponent };